export default __webpack_public_path__ + "assets/b2192fd47f27741a2c06d3839dcead1c.woff2";